var Backgrid = require('backgrid');
var Labels = EY.Consultation.Labels;

// A minimal implementation of Backgrid: http://backgridjs.com/
// Expects a non-empty Backbone collection, an array of columns in the backgrid basic format, and a Marionette region to render the grid.
// Sample columns-array:
//    [{
//        name: 'name',
//        label: Labels.Name,
//        editable: false,
//        cell: 'string'
//    }, {
//        editable: false,
//        cell: Action // Regular Backbone.View
//    }]
module.exports.show = function (options) {
    var collection = options.collection;
    var columns = options.columns;
    var region = options.region;
    var body = options.body || '';
    var grid = new Backgrid.Grid({
        className: 'table table-responsive',
        body: body,
        columns: columns,
        collection: collection,
        emptyText: Labels.NoDataFound
    });

    region.show(grid);
}; 


// WEBPACK FOOTER //
// ./js/Modules/UI/Grid.js